export const notFound = "*";
export const loginPath: string = "/login";
export const registrationPath: string = "/signup";
export const forgotPasswordPath: string = "/forgot";
export const successRegistrationPath: string = "/ready";
export const successResetPasswordPath: string = "/good-reset-password";
export const newPasswordFormPath: string = "/reset-password";
export const AboutUsPath: string = "/about";
export const MyProfilePath: string = "/profile";
export const ContactUsPath: string = "/contact";
export const TermsOfServicePath: string = "/terms-of-service";
/* ---------------------------------------------------- */

export const SettingsPath: string = "/settings";
export const HomePath: string = "/home";
export const ProjectRelativePath: string = "projects/";

/* ---------------------------------------------------- */


export function getNodeTableAbsPath(projectId: any): string {
    return `/projects/${projectId}/nodes`
}


export function getBranchTableAbsPath(projectId: any): string {
    return `/projects/${projectId}/branches`
}

export function getEquipmentTableAbsPath(projectId: any): string {
    return `/projects/${projectId}/equipments`
}


export function getCalculationTableAbsPath(projectId: any): string {
    return `/projects/${projectId}/calculations`
}

export function getTeamTabAbsPath(projectId: any): string {
    return `/projects/${projectId}/team`
}

export function getProjectSettingsTabAbsPath(projectId: any): string {
    return `/projects/${projectId}/settings`
}
